import { render } from "./DuplicateIndicator.vue?vue&type=template&id=2d68a18b&scoped=true"
import script from "./DuplicateIndicator.vue?vue&type=script&lang=js"
export * from "./DuplicateIndicator.vue?vue&type=script&lang=js"

import "./DuplicateIndicator.vue?vue&type=style&index=0&id=2d68a18b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d68a18b"]])

export default __exports__